import styled from '@emotion/styled';
import { Flex, Heading } from '@rebass/emotion';
import theme from '../../../styles/theme';
import { rem } from '../../../styles/theme/layout';

export const Wrapper = styled.div`
  text-align: center;
  max-width: ${rem(640)};
  margin: ${theme.space[3]} auto;
`;

export const Title = styled(Heading)`
  font-size: 2.5rem;
`;

export const BodyContent = styled.div`
  line-height: 1.8;
`;

export const CtaButton = styled.a`
  background: ${theme.colors.black};
  color: ${theme.colors.white};
  font-family: ${theme.fonts.fontSemi};
  text-transform: uppercase;
  display: block;
  cursor: pointer;
  margin: 0 ${theme.space[1]};
  padding: ${theme.space[2]} ${theme.space[3]};
  &:hover {
    background: ${theme.colors.darkGray};
  }
`;

export const ProductsWrapper = styled(Flex)`
  flex-wrap: wrap;
  justify-content: space-between;
`;

export default { Wrapper, Title, CtaButton, BodyContent };
